import { render, staticRenderFns } from "./CreateDns.vue?vue&type=template&id=7fc6b787&scoped=true&"
import script from "./CreateDns.vue?vue&type=script&lang=ts&"
export * from "./CreateDns.vue?vue&type=script&lang=ts&"
import style0 from "./CreateDns.vue?vue&type=style&index=0&id=7fc6b787&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fc6b787",
  null
  
)

export default component.exports